module.exports = __webpack_public_path__ + "static/img/fwxy-banner.13afbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fwxy-banner.jpg
// module id = uPdz
// module chunks = 0